<div 
  class="progress-bar-wrapper"
  [style.--color-completed]="colorCompleted()"
  [style.--color-incomplete]="colorIncomplete()"
>
  <!--@if (showPercentage()) {
    <div class="progress-label">
      <span class="progress-percentage">{{ formattedProgress() }}</span>
    </div>
  }-->
  <ci-icon 
    class="progress-bar__icon"
    name="walk" 
    scale="1.5x"
  ></ci-icon>
  
  <div class="progress-bars">
    @for (bar of bars(); track bar.index) {
      <div 
        class="progress-bar-item"
        [class.completed]="bar.completed"
        [class.is-center]="bar.isCenter"
        [class.grow-1]="bar.growClass === 'grow-1'"
        [class.grow-2]="bar.growClass === 'grow-2'"
        [class.grow-3]="bar.growClass === 'grow-3'"
        [class.grow-4]="bar.growClass === 'grow-4'"
        [attr.data-progress]="bar.isCenter ? formattedProgress() : null"
      ></div>
    }
  </div>
  
  <ci-icon 
    class="progress-bar__icon"
    name="bus" 
    scale="1.5x"
  ></ci-icon>
</div>
